import { Injectable } from "@angular/core";
import { select } from "d3-selection";
import { zoom } from "d3-zoom";

@Injectable()
export class D3Service {
  constructor() {}

  /** A method to bind a pan and zoom behaviour to an svg element */
  applyZoomableBehaviour(svgElement, containerElement) {
    const svg = select(svgElement);
    const container = select(containerElement);

    const zoomBehavior = zoom().on("zoom", (event: any) => {
      const transform = event.transform;
      container.attr(
        "transform",
        "translate(" +
          transform.x +
          "," +
          transform.y +
          ") scale(" +
          transform.k +
          ")",
      );
    });

    svg.call(zoomBehavior);
  }
}
